export enum TrainingType {
  Video = "VIDEO",
  Image = "IMAGE",
  Document = "DOCUMENT",
  Other = "OTHER"
}